module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box-content"
  }, [_c('h2', [_vm._v("Frequently Asked Questions")]), _vm._v(" "), _c('div', {
    staticClass: "faq-height"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content faq-tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "tab-inscription"
    }
  }, [_c('div', {
    staticClass: "accordion",
    attrs: {
      "id": "accordion-inscription"
    }
  }, [_c('div', {
    staticClass: "accordion-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-1"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_c('a', {
    staticClass: "text-danger pointer",
    on: {
      "click": function($event) {
        _vm.showInscriptionExamples()
      }
    }
  }, [_vm._v("Click here")]), _vm._v(" to view inscription examples to nudge your creativity.\n                                            ")])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs faq-nav-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab-inscription",
      "aria-controls": "tab-inscription",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Inscription / Engraving")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab-order",
      "aria-controls": "tab-order",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Order / Payment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab-quantity",
      "aria-controls": "tab-quantity",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Quantity / Location")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab-replicas",
      "aria-controls": "tab-replicas",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Keepsake Certificates")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-1"
    }
  }, [_vm._v("What are people putting on their pavers or plaques?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-2"
    }
  }, [_vm._v("What can I have engraved on my paver or plaque?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-2"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                                Any letter, number, symbol or punctuation mark found on a standard English keyboard can be engraved. Messages containing websites, phone numbers, social media handles, and/or manifestos are not permitted. Discriminatory, political, offensive or unsuitable messages as determined by California State University, Fullerton will be declined. California State University, Fullerton reserves the right to decline inscriptions for any reason. Should your inscription require revision, you will be contacted for assistance in submitting an alternative inscription.\n                                            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-3"
    }
  }, [_vm._v("How will my inscription appear on my paver or plaque?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-3"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                                All text will be centered and engraved in UPPERCASE, except if requested for proper name formatting (i.e., McKENZIE, DeBOUR, etc.).\n                                            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-4"
    }
  }, [_vm._v("How long can my message be?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-4"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t12” x 12” pavers can be engraved with one to ten (1-10) lines of text with up to twenty (20) characters per line.\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tTree Dedication inscriptions can be one to five (1-5) lines of text with up to twenty-five (25) characters per line.\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tStudy Nook inscriptions can be one to seven (1-7) lines of text with up to twenty-eight (28) characters per line.\n\t\t\t\t\t\t\t\t\t\t\t\t")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-5"
    }
  }, [_vm._v("Can I change my inscription?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-5"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                                Changes may be made to your order within 1 business day of receipt of your order confirmation, after which your order may be scheduled for production and changes may not be possible.\n                                            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "tab-order"
    }
  }, [_c('div', {
    staticClass: "accordion",
    attrs: {
      "id": "accordion-order"
    }
  }, [_c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-8"
    }
  }, [_vm._v("How do I place an order if I live in Alaska, Hawaii, or internationally?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-8"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                                Please call 1-888-223-0291 and a customer service specialist will be happy to assist you in placing your order.\n                                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-9"
    }
  }, [_vm._v("How long do I have to place my order?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-9"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                                Space is limited, so act now to ensure you are included in this exciting opportunity! Orders placed by Apr. 30, 2022 will be installed in Sept. 2022.")])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-10"
    }
  }, [_vm._v("What do I do if I haven't received my email order confirmation?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-10"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                                If you have not received your confirmation email, please check your junk folder. If you still cannot locate your confirmation, please call 1-888-223-0291 for additional assistance.\n                                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-12a"
    }
  }, [_vm._v("Is my purchase tax deductible?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-12a"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_c('p', [_vm._v("A portion of your donation may be tax deductible to the extent allowed by law. Additional tax deductibility information will be provided on your order confirmation.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-13"
    }
  }, [_vm._v("How do I pay by check?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-13"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_c('p', [_vm._v("Please call 1-888-223-0291 to receive an order form which can be completed and mailed along with your check payment.")]), _vm._v(" "), _c('p', [_vm._v("Please make checks payable to: CSFPF or Cal State Fullerton Philanthropic Foundation")]), _vm._v(" "), _c('p', [_vm._v("Please mail completed order form and check to: Titan Promenade Tribute Program | 2600 Nutwood Avenue, Suite 850 | Fullerton, CA 92832-3112")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-14"
    }
  }, [_vm._v("What do the proceeds of my order benefit?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-14"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                                The Titan Promenade Tribute Program is officially provided by California State University, Fullerton, with net proceeds benefiting the Cal State Fullerton Philanthropic Foundation.\n                                            ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "tab-quantity"
    }
  }, [_c('div', {
    staticClass: "accordion",
    attrs: {
      "id": "accordion-quantity"
    }
  }, [_c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-17"
    }
  }, [_vm._v("How many pavers or plaques are available?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-17"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                                Space is limited, so act now to ensure you are included in this exciting opportunity!\n                                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-18"
    }
  }, [_vm._v("How will I find my installed paver or plaque?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-18"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                                Once installed, you will receive a notification with further instruction on how to find your paver or plaque.\n                                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-181"
    }
  }, [_vm._v("When will my paver or plaque be installed?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-181"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                                Engraved pavers and plaques ordered by Apr. 30, 2022 will be installed in Sept. 2022.\n                                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-19"
    }
  }, [_vm._v("Where will my paver or plaque be installed?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-19"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                                Pavers and plaques will be featured on the Titan Promenade at Cal State Fullerton.\n                                            ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "tab-replicas"
    }
  }, [_c('div', {
    staticClass: "accordion",
    attrs: {
      "id": "accordion-replicas"
    }
  }, [_c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-22"
    }
  }, [_vm._v("What is a keepsake certificate?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-22"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                                Keepsake certificates are frameable certificates customized with your paver or plaque inscription. This not only authenticates your purchase but also can be given as a gift.\n                                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-group"
  }, [_c('div', {
    staticClass: "accordion-heading"
  }, [_c('a', {
    staticClass: "accordion-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse-23"
    }
  }, [_vm._v("When will I receive my keepsake certificate?")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion-body collapse",
    attrs: {
      "id": "collapse-23"
    }
  }, [_c('div', {
    staticClass: "accordion-inner"
  }, [_vm._v("\n                                                Keepsake certificates are mailed out within 2-4 weeks of successful order placement. Subject to timely inscription approval. Please call 1-888-223-0291 for more information.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72415437","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Faq.vue
// module id = i79S
// module chunks = 1